<script>
import _map from 'lodash/map';
import { Router, Route, links } from "svelte-routing";
import { setClient } from 'svelte-apollo';
import { client } from './apollo-client-hosted-forms';
import HostedForm from './routes/hosted-forms/HostedForm.svelte';
import NotFound from './routes/NotFound.svelte';
import Abstract3dBackground from './components/Abstract3dBackground.svelte'

setClient(client);

const isIframe = (window.parent !== window);
const brandBlue = [66, 134, 244];
const greekBlue = [55, 66, 250];
const brandBlueDark = _map(brandBlue, v => Math.round(v*0.4));
const greekBlueDark = _map(greekBlue, v => Math.round(v*0.4));
</script>

<div use:links class="app-wrapper">
    <!-- {#if isIframe} -->
        <div class="background-animation">
            {#if window.parent === window}
                <Abstract3dBackground />
            {:else}
                <Abstract3dBackground color1={brandBlueDark} color2={greekBlueDark} />
            {/if}
        </div>
    <!-- {/if} -->
    <div class="foreground">
        <Router>
            <Route path="/hosted/:formSlug" component={HostedForm} />
            <Route path="" component={NotFound} />
        </Router>
    </div>
    <script async defer src="https://www.google.com/recaptcha/enterprise.js?render={__GCP_RECAPTCHA_KEY_SCORE__}"></script>
</div>

<style>
@import 'styles/normalize.css';
@import 'styles/global.css';

/* https://codepen.io/smpnjn/pen/pobGMKp */

:global(html) {
    background: transparent;
}
:global(html),
:global(body) {
    height: 100% !important;
}
.app-wrapper {
    height: 100%;
    /* height: 100vh;
    overflow: visible;
    transform-style: preserve-3d;
    perspective: 2500px; */
}
.background-animation {
    display: none;
}
:global(.grecaptcha-badge) {
    opacity: 0;
    z-index: 0;
    transition: 500ms opacity;
}
@media only screen and (min-width: 480px) {
    /* :global(html) {
        background: #141414;
    } */
    .background-animation {
        display: block;
        position: fixed;
        /* border-radius: 3px; */
        overflow: hidden;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 0;
    }
    :global(.grecaptcha-badge) {
        opacity: 1;
        z-index: 2; /* z-index of foreground + 1 */
    }
}
.foreground {
    position: relative;
    z-index: 1;
    height: 100%;
    overflow: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scroll: touch;
}
</style>
